import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, Button, Modal, InputNumber } from 'antd';
const FormItem = Form.Item;

class MpaParkinglocationForm extends Component {

  state = {    
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {    
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {        
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;
    
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => {this.form = ref}}>
        <FormItem
          {...formItemLayout}
          label="Lokalita" >
          {getFieldDecorator('ParkingLocationID', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <ParkinglocationSelect onChange={(value) => { this.props.form.setFieldsValue({ ParkingLocationID: value });  }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Identifikátor zóny" >
          {getFieldDecorator('ExtID', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={99999999} />
          )}
        </FormItem>        
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {  
    if (this.props.type && this.props.type === 'modal') {
      return(
        <Modal
          width={650}
          title="Vytvoření nové lokality"
          visible={this.state.modalVisible}             
          onCancel={() => {
            this.props.onModalCancel();
            this.setState({modalVisible: false});                         
          }} 
          footer={<p></p>}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();    
    }
  }
}

const WrappedParkinglocationForm = Form.create()(MpaParkinglocationForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/MpaParkinglocationForm.js